<template>
  <div v-if="isHideRevenue !== undefined" class="wrapper">
    <div v-if="isHideRevenue">
      本ページへのアクセス権がありません
    </div>
    <div v-if="!isHideRevenue">
      <div>レポート出力条件一覧</div>
      <v-toolbar color="transparent" flat>
        <IntervalReportButtonAdd @click="onButtonAddClicked()" />
        <v-spacer />
        <IntervalReportSearchBox @onTextEnter="onTextEnter" />
        <PageSelect
          :value="intervalReport"
          @input="pagination"
          style="width:160px;"
          class="pl-4"
        />
      </v-toolbar>
      <IntervalReportList :items="intervalReport.items" />
      <IntervalReportModalAdd
        v-if="displayAddModal"
        :visible="displayAddModal"
        :defaultInsertionOrderId="defaultSetInsertionOrderId"
        :source="source"
        @clickSubmit="onSubmit"
        @cancel="cancel"
      />
    </div>
  </div>
</template>

<script>
import IntervalReportButtonAdd from '@/components/Advertiser/Report/IntervalReport/IntervalReportButtonAdd'
import IntervalReportSearchBox from '@/components/Advertiser/Report/IntervalReport/IntervalReportSearchBox'
import IntervalReportModalAdd from '@/components/Advertiser/Report/IntervalReport/IntervalReportModalAdd'
import IntervalReportList from '@/components/Advertiser/Report/IntervalReport/IntervalReportList'
import PageSelect from '@/components/Shared/Search/PageSelect'
import { accountInitializer } from '@/mixins/accountInitializer'
import { setDrawerTypeAdvertiser } from '@/mixins/setDrawerTypeAdvertiser'
import { setToolbarTypeAdvertiser } from '@/mixins/setToolBarTypeAdvertiser'
import { mapActions, mapGetters } from 'vuex'
import { snackbarType } from '@/vuex/modules/ui/snackbar/constants'
import { Account } from '@/models/Account'
export default {
  name: 'IntervalReport',
  components: {
    IntervalReportButtonAdd,
    IntervalReportSearchBox,
    IntervalReportList,
    IntervalReportModalAdd,
    PageSelect,
  },
  mixins: [
    accountInitializer,
    setDrawerTypeAdvertiser,
    setToolbarTypeAdvertiser,
  ],
  data() {
    return {
      displayAddModal: false,
      loading: true,
      isHideRevenue: undefined,
      defaultSetInsertionOrderId: undefined,
      source: 'origin',
    }
  },
  computed: {
    ...mapGetters('advertiser/reportIntervalReport', [
      'keyword',
      'advertiserId',
      'pageNo',
      'intervalReport',
    ]),
    userBelongType() {
      return this.$store.getters['account/belongType']
    },
    userBelongId() {
      return this.$store.getters['account/belongId']
    },
    userType() {
      return this.$store.getters['account/userType']
    },
  },
  watch: {
    isAuthed() {
      if (this.isAuthed) {
        this.initSearchItems()
        this.initSearch()
      }
    },
    async userBelongType() {
      this.setIsHideRevenue()
    },
  },
  created() {
    this.setSearchKeyword(this.$route.query.id)
    this.initSearch()
    this.setIsHideRevenue()
    this.setDefaultSetInsertionOrderId()
    this.setDefaultSource()
    this.isDefaultOpenIntervalReportModal()
  },
  beforeDestroy() {
    this.reset()
  },
  methods: {
    ...mapActions('advertiser/reportIntervalReport', {
      initSearchItems: 'INIT_SEARCH_ITEMS',
      setSearchKeyword: 'SET_SEARCH_KEYWORD',
      setPageNo: 'SET_SEARCH_PAGE_NO',
      setIntervalReport: 'SET_INTERVAL_REPORT',
      reset: 'RESET',
    }),
    ...mapActions('snackbar', {
      showSnackbar: 'SHOW_SNACKBAR',
    }),
    async setIsHideRevenue() {
      if (!this.userBelongType || !this.userBelongId || !this.userType) return

      this.isHideRevenue = await Account.isHideRevenue(
        this.userBelongType,
        this.userBelongId,
        this.userType,
      )
    },
    updateIntervalReport() {
      this.setIntervalReport({
        keyword: this.keyword,
        advertiserId: this.advertiserId,
        pageNo: this.pageNo,
      })
    },
    initSearch() {
      this.initSearchItems(this.$route.params.advertiserId)
      this.updateIntervalReport()
    },
    onTextEnter(searchWord) {
      this.setSearchKeyword(searchWord)
      this.updateIntervalReport()
    },
    pagination(pageNo) {
      this.setPageNo(pageNo)
      this.updateIntervalReport()
    },
    onButtonAddClicked() {
      this.displayAddModal = true
    },
    onSubmit() {
      this.displayAddModal = false
      this.showSnackbar({
        type: snackbarType.SUCCESS,
        message: 'レポート定期メール配信設定を登録しました。',
      })
      this.resetDefaultSetting()
      this.reset()
      this.initSearch()
    },
    cancel() {
      this.displayAddModal = false
      this.resetDefaultSetting()
    },
    setDefaultSetInsertionOrderId() {
      const insertionOrderId = this.$route.query.insertionOrderId
      if (insertionOrderId !== undefined) {
        this.defaultSetInsertionOrderId = Number(insertionOrderId)
      }
    },
    isDefaultOpenIntervalReportModal() {
      if (this.defaultSetInsertionOrderId !== undefined) {
        this.displayAddModal = true
      }
    },
    setDefaultSource() {
      if (this.$route.query.source === undefined) {
        this.source = 'origin'
        return
      }
      this.source = this.$route.query.source
    },
    resetDefaultSetting() {
      this.source = 'origin'
      this.defaultSetInsertionOrderId = undefined
    },
  },
}
</script>

<style scoped>
.wrapper {
  width: 100%;
  height: 100%;
}
</style>
